<template>
  <content-with-loading-skeleton
    :isLoading="isLoading"
    loadingMessage="Loading Player Subscription Data..."
    :isWithMessage="true"
  >
    <template #loaded>
      <TopBar />
      <PageSection>
        <PlayersFilters v-model="data.filters" />
      </PageSection>
      <PageSection>
        <!-- Debugging Helper -->
        <!-- <pre class="overflow-y-scroll h-60">data.bindings from Player Subscription Editor View: {{ data.bindings }}</pre> -->
        <SubscriptionBindings v-model="data.bindings" />
      </PageSection>
      <FloatingFooterButtons>
        <div class="flex flex-row-reverse gap-2">
          <SaveSubscriptionButton ref="saveSubscriptionButtonRef" @save="onSave" />
          <ExitButton
            v-bind="{hasUnsavedChanges, unsetHasUnsavedChanges}"
            @exit="onExit"
            @saveAndExit="onSaveAndExit"
          />
        </div>
      </FloatingFooterButtons>
    </template>
  </content-with-loading-skeleton>
</template>


<script setup lang="ts">
import PageSection from '@/components/layouts/PageSection.vue';
import TopBar from './TopBar/TopBar.vue';
import {onBeforeMount}  from 'vue'
import { onBeforeRouteUpdate, useRoute } from 'vue-router'
import FloatingFooterButtons from '@/components/layouts/FloatingFooterButtons.vue';
import SaveSubscriptionButton from './SaveSubscriptionButton/SaveSubscriptionButton.vue';
import ExitButton from '@/components/Dialog/ButtonsWithDialog/ExitButton/ExitButton.vue';
import sharedRefs from './sharedRefs';
import router from '@/router';
import PlayersFilters from './PlayersFilters/PlayersFilters.vue';
import SubscriptionBindings from './SubscriptionBindings/SubscriptionBindings.vue';
import { updateReactiveObject } from '@/helpers/utils/utils';
import { usePlayerSubscription } from './composables/playerSubscription';
const { data } = usePlayerSubscription();


const { loadPlayerSubscription, initializeHasUnsavedChangesWatcher, hasUnsavedChanges, unsetHasUnsavedChanges, isLoading } = usePlayerSubscription();
initializeHasUnsavedChangesWatcher();

const route = useRoute()

const currentSubscriptionId = route.params.id as string;
const { saveSubscriptionButtonRef } = sharedRefs;

function onExit() {
  router.push({ path: '/player-subscriptions' })
}

async function onSave(savedData: any) {
  // console.log({ savedData, data }); // Debugging Helper
  updateReactiveObject(data, savedData);
}

async function onSaveAndExit() {
  await saveSubscriptionButtonRef.value.savePlayerSubscription();
  router.push({ path: '/player-subscriptions' })
}

onBeforeMount(async () => {
  await loadPlayerSubscription(currentSubscriptionId);
});

onBeforeRouteUpdate(async (newRoute) => {
  if(newRoute.name === "player-subscription-editor") {
    const newPlaylerSubscriptionId = newRoute.params.id;
    await loadPlayerSubscription(newPlaylerSubscriptionId);
  }
})
</script>



<style lang="scss" scoped>
</style>
